module.exports = __webpack_public_path__ + "ff8c43793c6aa48f1c43c0ef0c89550a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icon-user.svg
// module id = z5yw
// module chunks = 0